/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import { PatientList } from "./PatientList";

import "./styles.scss";

type Props = {
	admissionQueueModalShow: boolean;
	setAdmissionQueueModalShow: (filterModalShow: boolean) => void;
	setQueueAdmissionData: (value: QueueAdmissionData) => void;
	setPatientAdmissionModalShow: (value: boolean) => void;
};

export function AdmissionQueueModal({
	admissionQueueModalShow,
	setAdmissionQueueModalShow,
	setQueueAdmissionData,
	setPatientAdmissionModalShow,
}: Props) {
	const [search, setSearch] = useState("");

	const MODAL_TITLE = "Fila de Admissão em Leito";
	const MODAL_HEIGHT = "67vh";

	const handleCloseModal = () => setAdmissionQueueModalShow(false);

	function handlePatientAdmit(surgicalAttendance: SurgicalAttendance) {
		setPatientAdmissionModalShow(true);
		setQueueAdmissionData({
			attendanceId: surgicalAttendance.attendanceId,
			surgicalAttendanceId: surgicalAttendance.id,
			patientName: surgicalAttendance.patient.name,
			expertiseId: surgicalAttendance.expertiseId,
			expertiseName: surgicalAttendance.expertise.name,
			isQueueAdmission: true,
		});
	}

	return (
		<Modal size="lg" show={admissionQueueModalShow} onHide={handleCloseModal}>
			<Modal.Header className="d-flex justify-content-center border-0">
				<Modal.Title className="fs-2">{MODAL_TITLE}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<PatientList
					search={search}
					setSearch={setSearch}
					onPatientAdmit={handlePatientAdmit}
					height={MODAL_HEIGHT}
					showSearch={true}
					searchPlaceholder="Pesquisar paciente"
				/>
			</Modal.Body>

			<Modal.Footer className="d-flex gap-2 border-0">
				<Button variant="secondary" className="py-2" onClick={handleCloseModal}>
					Fechar
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
